"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var openapi_exports = {};
__export(openapi_exports, {
  OpenApiExtension: () => OpenApiExtension,
  openApiOptions: () => openApiOptions
});
module.exports = __toCommonJS(openapi_exports);
var import_core = require("@tiptap/core");
var import_extension_code_block = __toESM(require("@tiptap/extension-code-block"));
var import_mode = require("../openapi/mode");
var import_codeblock = require("./codeblock");
const openApiOptions = {
  ...import_codeblock.codeBlockOptions,
  defaultLanguage: import_mode.openApiNodeName
};
const OpenApiExtension = import_extension_code_block.default.extend({
  name: import_mode.openApiNodeName,
  group: "block",
  marks: "inline-comment",
  parseHTML() {
    return [
      {
        tag: "div.openapi-spec",
        preserveWhitespace: "full"
      },
      {
        tag: "pre.openapi-spec",
        preserveWhitespace: "full"
      }
    ];
  },
  // The tag this writes is the tag `parseHTML` above looks for, so a block that leaves the
  // document as html comes back as the same node rather than as a plain code block — and
  // with its mode, which travels as `data-view-mode`.
  renderHTML({ node, HTMLAttributes }) {
    return [
      "div",
      (0, import_core.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes, { class: "openapi-spec" }),
      [
        "code",
        {
          class: node.attrs.language !== void 0 ? this.options.languageClassPrefix + node.attrs.language : null
        },
        0
      ]
    ];
  },
  addAttributes() {
    return {
      language: {
        default: import_mode.openApiNodeName
      },
      viewMode: {
        default: import_mode.defaultOpenApiViewMode,
        // Html is one of the ways a block leaves and re-enters a document (copy, paste,
        // export), so the mode travels with it there too — under a data attribute, and
        // through the same normalisation as every other untrusted source of it.
        parseHTML: /* @__PURE__ */ __name((element) => (0, import_mode.normalizeOpenApiViewMode)(element.getAttribute("data-view-mode")), "parseHTML"),
        renderHTML: /* @__PURE__ */ __name((attributes) => ({ "data-view-mode": (0, import_mode.normalizeOpenApiViewMode)(attributes.viewMode) }), "renderHTML")
      }
    };
  }
});
//# sourceMappingURL=openapi.js.map
